import React from "react"
import { View, Text, Slider } from "react-ame-components"
import ShowCase from "../components/Showcase"

export class SliderExample extends React.Component {
  state = {
    value: 20000,
    happy: 50,
  }
  render() {
    return (
      <ShowCase
        centerGrid
        title="Componente Slider"
        description="Componente para seleção de valores no tipo range">
        <View
          marginTop="medium"
          marginBottom="medium"
          padding="nano">
          <View
            marginBottom="medium"
            padding="nano">
            <Text
              fontSize="medium"
              fontWeight="bold">
              Exemplo com monetary
            </Text>
          </View>
          <Slider
            minAmount={20000}
            maxAmount={700000}
            value={this.state.value}
            step={5000}
            onChange={value => {
              this.setState({ value })
            }}
          />
        </View>
        <View marginTop="large">
          <View
            marginTop="medium"
            marginBottom="medium"
            padding="nano">
            <Text
              fontSize="medium"
              fontWeight="bold">
              Exemplo com icones
            </Text>
          </View>
          <Slider
            leftIcon="faces-sad-outline"
            rightIcon="faces-happy-outline"
            infoLabel="icon"
            minAmount={0}
            maxAmount={100}
            monetary={false}
            value={this.state.happy}
            step={1}
            onChange={volume => {
              this.setState({ volume })
            }}
            label={false}
          />
        </View>
      </ShowCase>
    )
  }
}
